
export enum SectionsRoutes {
    HOME = "/",
    ABOUT = "/about",
    ART = "/art",
    TECH = "/tech",
    CONTACT = "/contact"
}